import { Component, inject, input, OnInit, signal } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { TransportDataService } from '@myarvato/modules/transport/services';
import { DetailViewDto } from '@myarvato/modules/transport/models';
import { DetailsComponent } from '@myarvato/modules/transport/details';
import { Tooltip } from 'primeng/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomizationTranslationService } from '@myarvato/shared/services';
import { ButtonModule } from 'primeng/button';
import { ErrorMessageComponent } from '@myarvato/components/message';
import { ErrorMessage } from '@myarvato/shared/models';

@Component({
  selector: 'transport-tracking-tab',
  imports: [DayjsPipe, DetailsComponent, Tooltip, ButtonModule, TranslatePipe, ErrorMessageComponent],
  templateUrl: './tracking-tab.component.html',
  styleUrl: './tracking-tab.component.scss',
})
export class TrackingTabComponent implements OnInit {
  // Inputs
  public readonly transportReference = input.required<string>();

  // Injections
  private readonly transportDataService = inject(TransportDataService);
  private readonly customizationTranslationService = inject(CustomizationTranslationService);

  // Change Detection
  protected readonly lastUpdate = signal<Dayjs>(dayjs());
  protected readonly details = signal<DetailViewDto | undefined>(undefined);
  protected readonly errorMessage = signal<ErrorMessage | undefined>(undefined);

  public ngOnInit(): void {
    this.loadDetails();
  }

  protected loadDetails(): void {
    this.transportDataService.getDetailsById(this.transportReference()).subscribe({
      next: (details) => {
        if (details) {
          this.details.set(details);
        }
      },
      error: (error) => {
        console.error('Error loading transport details:', error);
        const errorCode = error?.error?.code || 'G0400';
        const errorTranslationTitle = this.customizationTranslationService.getTranslation(
          `errors.${errorCode}.title`,
          'errors.G0400.title',
        );
        const errorTranslationDescription = this.customizationTranslationService.getTranslation(
          `errors.${errorCode}.description`,
          'errors.G0400.description',
        );

        this.errorMessage.set({ summary: errorTranslationTitle, detail: errorTranslationDescription });
      },
      complete: () => {
        this.lastUpdate.set(dayjs());
      },
    });
  }

  protected openUrl(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
